// src/components/QuizHeader.jsx
import React from "react";

export default function QuizHeader({
  mode,
  onModeChange,
  moreInfoEnabled,
  onToggleMoreInfo,
}) {
  const titleMap = {
    india: "India Map State Quiz 💎",
    passes: "India Map Passes Quiz 💎",
    world: "World Map Quiz 💎",
  };

  const subtitleMap = {
    india: "Blink karne wali state ka sahi naam choose karo.",
    passes: "Important passes / ghats identify karo.",
    world: "World map mode coming soon.",
  };

  return (
    <div className="quiz-header">
      <div className="title-area">
        <h1 className="quiz-title">{titleMap[mode] || titleMap.india}</h1>
        <p className="quiz-subtitle">{subtitleMap[mode]}</p>

        <div className="mode-tabs">
          <button
            className={
              mode === "india" ? "mode-tab mode-tab-active" : "mode-tab"
            }
            onClick={() => onModeChange("india")}
          >
            States
          </button>

          <button
            className={
              mode === "passes" ? "mode-tab mode-tab-active" : "mode-tab"
            }
            onClick={() => onModeChange("passes")}
          >
            Passes / Ghats
          </button>

          <button
            className={
              mode === "world"
                ? "mode-tab mode-tab-active"
                : "mode-tab mode-tab-disabled"
            }
            onClick={() => onModeChange("world")}
          >
            World <span className="pill-soon">Coming soon</span>
          </button>
        </div>
      </div>

      {/* RIGHT SIDE – More info toggle sirf India ke liye */}
      <div className="header-right">
        {mode === "india" && (
          <button
            type="button"
            className={
              "more-info-toggle" +
              (moreInfoEnabled ? " more-info-toggle-on" : "")
            }
            onClick={onToggleMoreInfo}
          >
            <span className="more-info-dot" />
            {moreInfoEnabled ? "More info: ON" : "More info: OFF"}
          </button>
        )}
      </div>
    </div>
  );
}
